import store from "./store";
import routes from "./routes";

export default {
  store,
  routes,
};
